(function (Checkout, $, undefined) {

  var m;

  Checkout.init = function() {

    console.log(Shopify.Checkout.step);
    if(Shopify.Checkout.step == 'contact_information') {
      ga('set', 'page', 'ShippingForm');
      ga('send', 'pageview');
    }
    else if(Shopify.Checkout.step == 'shipping_method') {
      ga('set', 'page', 'ShippingMethod');
      ga('send', 'pageview');
    }
    else if(Shopify.Checkout.step == 'payment_method') {
      ga('set', 'page', 'Payment');
      ga('send', 'pageview');
    }

    
    // Special initialization for a draft order
    if(Checkout.isDraftPage()) {
      Checkout.initDraft();

      if(Checkout.isThankYouPage()) {
        $('.estimate-only').hide();
        $('.draft-only').show();
      }

      if(Shopify.Checkout.step == "thank_you") {
        ga('set', 'page', 'FinalOrderConfirmation');
        ga('send', 'pageview');
      }
    }
    else {
      Checkout.initEstimate();
      if(Checkout.isThankYouPage()) {
        $('.draft-only').hide();
        $('.estimate-only').show();
      }

      if(Shopify.Checkout.step == "thank_you") {
        ga('set', 'page', 'EstOrderConfirmation');
        ga('send', 'pageview');
      }
    }
	if(Cookies.get('fossiltaxes')==null){
		 Cookies.set('fossiltaxes', sessionStorage.getItem("fossiltaxes"),{ expires: 365 });
	}

    App.updatePrice();
    console.log(App.m.prices);

    Checkout.customizeUI();
    Checkout.bindUIActions();

    
    if(Checkout.isThankYouPage() && !draftUniqueId) {
      Checkout.showThankYou();
    }

    // Change return to cart to return to services
    var $prev = $('.step__footer__previous-link');
    if($prev.length > 0 && $prev.attr('href').indexOf('cart') >= 0) {
      $prev.attr('href', '/pages/services#step3');
      $prev.find('.step__footer__previous-link-content').text($('#change-services-label').text());
    }
  }

  Checkout.isDraftPage = function() {
    return checkoutType == 'draft';
  }

  Checkout.isThankYouPage = function() {
    return (typeof Shopify.Checkout != "undefined" && Shopify.Checkout.step == "thank_you") ||
    (checkoutType == 'initial' && $('div[data-step="thank-you"]').length > 0 || window.location.href.indexOf('thank_you') > 0);
  }

  Checkout.showThankYou = function() {
    $('.checklist').show();

     $('body').on('click', '#print-label', function(e) {
      e.preventDefault();
      
      var mywindow = window.open('', 'Shipping Checklist', 'height=400,width=600');

      mywindow.document.write('<html><head><title>' + document.title  + '</title>');
      mywindow.document.write('</head><body >');
      mywindow.document.write($('.print-checklist').html());
      mywindow.document.write('</body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      setTimeout(function() {
        mywindow.print();
      }, 1000);

      return true;
     });

    Cookies.remove('fossilrepair');
  }

  Checkout.bindUIActions = function () {
     $('.change-draft h5').on('click', function() {
        $('.change-options').toggle();
      });

      $('#toggle-mobile-order').on('click', function(e) {
        e.preventDefault();
        $('div.sidebar').toggle();
      });
      
      $('#change-services').on('click', function() {
        var variants = [];
        $('.variant:checked').each(function() {
          variants.push($(this).attr('index'));  
        });
                          
        var params = {
          variants : variants,
            action: 'items',
            notes: $('#change-notes').val(),
            store: App.site
        }
        
        $.post(apiEndpoint + '/draftorders/'+ App.m.draft.id + '/update', params, function(response) {
          window.location.href = response.draft.url;
          console.log(response);
        });
      });
      
      $('#cancel-return').on('click', function() {

        var confirm = window.confirm(jsData.confirmReject);
        if(confirm) {
          var params = {
              action: 'return',
              notes: $('#change-notes').val(),
              store: App.site
          };
          
          $.post(apiEndpoint + '/draftorders/'+ App.m.draft.id + '/update', params, function(response) {
            window.location.href = response.draft.url;
            console.log(response);
          });
        }
      });
      
      $('#cancel-keep').on('click', function() {
        
        var confirm = window.confirm(jsData.confirmReject);
        if(confirm) {
          var params = {
              action: 'cancel',
              notes: $('#change-notes').val(),
              store: App.site
          };
          
          $.post(apiEndpoint + '/draftorders/'+ App.m.draft.id + '/update', params, function(response) {
            window.location.href = 'https://' + App.site + '-services-fossilgroup.myshopify.com/pages/order-cancelled';
          });
        }
      });
	  
	  
	  //When changing the phone number
	  $('#checkout_shipping_address_phone').on('focus',function(){
		$('.phonevalidation').hide();
		
	});
	

      // When the zip changes.
    $('#checkout_shipping_address_zip').on('blur', function(){
      console.log('blur');
      var zipcode = $(this).val();
      if(zipcode) {
        Checkout.validateAddress(zipcode);
      }
    });

    $('#checkout_shipping_address_city').on('blur', function(){
      var zipcode = $('#checkout_shipping_address_zip').val();
      if(zipcode) {
        Checkout.validateAddress(zipcode);
      }
    });
	

	//pincode validation for US
	
	$("#checkout_shipping_address_id").on('change',function(){
	if(App.country == 'us') 
	{
		var data=$("#checkout_shipping_address_id option:selected").attr("data-properties");
		var obj = jQuery.parseJSON(data);
		s= obj.zip;
		s = s.substring(0,5);
		obj.zip=s;
		var myJSON = JSON.stringify(obj);
		//var data=$("#checkout_shipping_address_id option:eq(1)").attr("data-properties",myJSON);
		var data=$("#checkout_shipping_address_id option:selected").attr("data-properties",myJSON);
	}
	});
	
	
	window.setInterval(function(){
	if(App.country == 'us') 
	{
		var s=$('#checkout_shipping_address_zip').val();
		if(typeof s != 'undefined')
		{
		s = s.substring(0,5);
		$('#checkout_shipping_address_zip').val(s);
		}
	}
	}, 100);
	
	//pincode validation for billing address - US
	
	
	if(App.country == 'us') {
	$('#checkout_billing_address_zip').attr('maxlength','5');
	}
	$("#checkout_billing_address_id").on('change',function(){
	if(App.country == 'us') 
	{
		var data=$("#checkout_billing_address_id option:selected").attr("data-properties");
		
		var obj = jQuery.parseJSON(data);
		s= obj.zip;
		s = s.substring(0,5);
		console.log(s);
		obj.zip=s;
		var myJSON = JSON.stringify(obj);
		
		var data=$("#checkout_billing_address_id option:selected").attr("data-properties",myJSON);
		$('#checkout_billing_address_zip').val(s);
	}
	});
	
	this.inhousesession = sessionStorage.getItem("inhouse");
	this.inhouse = Cookies.get('inhouse');
    //this.agent = (Utils.queryParam('agent') != undefined);
	this.agent = Cookies.get('agent');
	this.agentsession = sessionStorage.getItem("agent");
	this.store = Cookies.get('fossilstore');
	this.storeSession = sessionStorage.getItem("fossilstore");

    // In house agents shouldn't have a store set.
	if((this.store !=null) || (this.storeSession !=null))
	{
		if(this.inhouse || this.inhousesession) {
		  $("#return_home").attr("href", "{{ shop.url }}/?inhouse=1&store=" +this.storeSession);
		}else if(this.agent || this.agentsession) {
		  $("#return_home").attr("href", "{{ shop.url }}/?agent=1&store=" +this.storeSession);
		}else{
		  $("#return_home").attr("href", "{{ shop.url }}/?store=" +this.storeSession);
		}
	} else{
		if(this.inhouse || this.inhousesession) {
		  $("#return_home").attr("href", "{{ shop.url }}/?inhouse=1");
		}
		
		if(this.agent || this.agentsession) {
		  $("#return_home").attr("href", "{{ shop.url }}/?agent=1");
		}
	}

	window.setInterval(function(){
	if(App.country == 'us') 
	{
		var s=$('#checkout_billing_address_zip').val();
		if(typeof page_name != 'undefined')
		{
		s = s.substring(0,5);
		$('#checkout_billing_address_zip').val(s);
		}
	}
	}, 100);
	
    // Set city value.
    $('body').on('click', '.city-suggestions li', function() {
      $('#checkout_shipping_address_city').val($(this).find('.city').text());
      var state = $(this).find('.state').text();
      console.log(state);
      $('#checkout_shipping_address_province option[data-code="' + state + '"]').prop('selected', true);
    });

  }
  

  Checkout.customizeUI = function() {

    // Show "estimate" order name even on draft orders.
    if(estimateOrder) {
      $('.os-order-number').text('Order ' + estimateOrder);
    }

    // Hide "Cart" link.
    $('.breadcrumb .breadcrumb__item').first().hide();

    // Add a mininum length to telephone fields.
    $('input[type=tel]').attr('minlength', jsData.phoneLength);
	
	//setting the maximum length to Zipcode fields.
	if(App.country == 'us') {
	$('#checkout_shipping_address_zip').attr('maxlength','5');
	}
	

    // Add a second email field for extra validation by cloning the 
    // original field.
    $email = $('#checkout_email');
    if($email.length > 0) {
      $email.addClass('checkout-email');
      var $clone = $('.section--contact-information .fieldset .field').first().clone();
      $clone.find('label').text('Confirm Email');
      $('.section--contact-information .fieldset').first().append($clone);
    }

    // Hide tax items
    $('tr.product').each(function() {
      var name = $(this).find('.product__description__name').text();
      var prop = $(this).find('.product__description__property');
      if(prop.length > 0 && name.indexOf('tax') >= 0) {
        $(this).hide();
      }

      // Don't show line items properties either.
      prop.hide();
    });

    // In Canada the apartment number comes first.
    if(App.country == 'ca') {
      $('[data-address-field="address1"]').css('float', 'right');
    }

    // See if we should translate to french.
    if(App.country == 'ca' && checkoutLanguage == 'French') {
      Checkout.translateCAtoFrench();
      /*setTimeout(function() {
        Checkout.translateCAtoFrench();
      }, 2000);*/
    }

     // Validate checkout.
    $('.step__footer__continue-btn').on('click', function(e) {
      
      $emails = $('.checkout-email');
      if($emails.length == 2) {
        var email = $($emails.get(0)).val().toLowerCase();
        var email2 = $($emails.get(1)).val().toLowerCase();
        if(email != email2) {
	        e.preventDefault(); 
          $emails.closest('.field').addClass('field--error');
          return false;
        }
      }
		
      // Validate phone number for US.
	 
      var addedPhoneNumber = $('#checkout_shipping_address_phone').val();
	  $('.phonevalidation').hide();
	    if(App.country == 'us') {		  		  
         if($('#checkout_shipping_address_phone').val() !=null) {		  
          
           addedPhoneNumber = addedPhoneNumber.replace(/\s+/g, "");
           var phoneno = /^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/		  
           var phoneno2 = /((9){10})|(^\(?([9]{3}|[1]{3}|[0]{3}|[2]{3}|[4]{3}|[5]{3}|[6]{3}|[7]{3}|[8]{3}|[3]{3})\)?[-. ]?([9]{3}|[1]{3}|[0]{3}|[2]{3}|[4]{3}|[5]{3}|[6]{3}|[7]{3}|[8]{3}|[3]{3})[-. ]?([9]{4}|[1]{4}|[0]{4}|[2]{4}|[4]{4}|[5]{4}|[6]{4}|[7]{4}|[8]{4}|[3]{4}))$/
          
           if(!addedPhoneNumber.match(phoneno) || addedPhoneNumber.match(phoneno2)) {
            $('#checkout_shipping_address_phone').closest('.field').addClass('field--error');
				var phoneValidation="<div class='phonevalidation'>Please enter valid Phone Number</div>"
				  
				$('.section--shipping-address .section__content').after(phoneValidation);
              return false;				  
           }
           else {
              return true;
           }
         }	
      }
	  

      $('#missing-terms').hide();
      if($('#checkout_terms_and_conditions').length > 0 && !$('#checkout_terms_and_conditions').is(':checked')) {
        e.preventDefault();
        $('#missing-terms').fadeIn();
        return false;
      }

      if(Shopify.Checkout.step == 'contact_information') {

        // Removing the carriage return from address.
        if($('#checkout_shipping_address_address1').val() != null)
        {
          var addrs = $('#checkout_shipping_address_address1').val().replace(/\n/g, " ");
          addrs = addrs.trim();
          $('#checkout_shipping_address_address1').val(addrs);
        }	

        // Validate address before continuing;
        var zipcode = $('#checkout_shipping_address_zip').val();
        if(zipcode) {
          e.preventDefault();
          Checkout.validateAddress(zipcode,
            function() {
              $('form.edit_checkout').submit();
            },
            function() {
              console.log('invalid');
            }
          );
        }
      }

      // Validate phone length.
      if(Shopify.Checkout.step == 'contact_information') {
        $('#checkout_shipping_address_phone').each(function() {
          // if($(this).is(':visible') && $(this).attr('minlength') > $(this).val().length) {
          //   e.preventDefault();
          //   $(this).closest('.field').addClass('field--error');
          // }
        });
      }
    });
  }

  Checkout.initEstimate = function() {

    if(Checkout.isThankYouPage()) {
      $('.section__content').hide();
    }

    // Change the "your order is free" message.
    $('div[data-payment-subform="free"] p').text(jsData.checkout.freeOrderText);

    $('.estimate-summary').show();
    $('div.main').addClass('estimate');
    $('.signature-upon-delivery').hide();

    if(App.country == 'uk') {
      $('#checkout_shipping_address_address1').each(function() {
          var attrs = {};        
          $.each(this.attributes, function() {
            attrs[this.name] = this.value;
          });
          
          $(this).replaceWith($('<textarea rows=4>').prop(attrs));
      });
    }
  }

  // Show the tax line in an order draft.
  Checkout.showDraftTax = function(tax) {
    console.log('drafttax');

    var sub = $('.total-line--subtotal span');
    if(sub.length > 0) {
      console.log('sub');
      var subText = sub.text().replace(
        Utils.getCurrencySymbol(), '')
        .replace('CAD', '')
        .replace('$', '')
        .replace (' ', '')
        .trim();

      console.log(subText);
      subText = parseFloat(subText);
      subText -= tax;
      $('.total-line--subtotal span').text(Utils.formatPrice(subText));

      if(draftTaxGST || draftTaxQST) {
         var taxLines = '<tr data-checkout-taxes="" class="total-line total-line--taxes"> ' +
          '<td class="total-line__name">QST/PST Tax</td> ' + 
          '<td class="total-line__price"><span data-checkout-total-taxes-target="0" class="order-summary__emphasis">' + Utils.formatPrice(draftTaxQST) + '</span></td></tr>';

          taxLines += '<tr data-checkout-taxes="" class="total-line total-line--taxes"> ' +
          '<td class="total-line__name">GST/HST Tax</td> ' + 
          '<td class="total-line__price"><span data-checkout-total-taxes-target="0" class="order-summary__emphasis">' + Utils.formatPrice(draftTaxGST) + '</span></td></tr>';

          $('.total-line--taxes').replaceWith(taxLines);
      }
      else {
        $('.total-line--taxes span').text(Utils.formatPrice(tax));
      }
      $('.total-line--taxes').removeClass('hidden');
    }
    else {
      $('.total-line-table').find('thead').after('')
      var lines = '<tbody class="total-line-table__tbody">';

      lines += '<tbody class="total-line-table__tbody" style="margin-bottom:10px"><tr data-checkout-shipping="" class="total-line total-line--shipping"> ' +
      '<td class="total-line__name">Shipping</td> ' + 
      '<td class="total-line__price"><span data-checkout-total-shipping-target="0" class="order-summary__emphasis">' + Utils.formatPrice(0) + '</span></td></tr>';

      console.log(draftTaxGST);
      console.log(draftTaxQST);

      if(draftTaxGST || draftTaxQST) {
        lines += '<tr data-checkout-taxes="" class="total-line total-line--taxes"> ' +
          '<td class="total-line__name">QST/PST Tax</td> ' + 
          '<td class="total-line__price"><span data-checkout-total-taxes-target="0" class="order-summary__emphasis">' + Utils.formatPrice(draftTaxQST) + '</span></td></tr>';

          lines += '<tr data-checkout-taxes="" class="total-line total-line--taxes"> ' +
          '<td class="total-line__name">GST/HST Tax</td> ' + 
          '<td class="total-line__price"><span data-checkout-total-taxes-target="0" class="order-summary__emphasis">' + Utils.formatPrice(draftTaxGST) + '</span></td></tr>';
      }
      else {
        lines += '<tr data-checkout-taxes="" class="total-line total-line--taxes"> ' +
          '<td class="total-line__name">Taxes</td> ' + 
          '<td class="total-line__price"><span data-checkout-total-taxes-target="0" class="order-summary__emphasis">' + Utils.formatPrice(tax) + '</span></td></tr>';
      }
      
      lines += '</tbody>';

        $('.total-line-table').find('thead').after(lines);
    }
  }

  Checkout.initDraft = function() {

    $('.default-summary').show();
    $('div.main').addClass('draft');

    // Show the hold options.
    $('.hold').show();

    if(Shopify.Checkout.step == 'shipping_method' || Shopify.Checkout.step == 'payment_method') {

      // There's no way to access the draft order id from liquid so we need
      // to pull the unique key from the URL and use that as a lookup.
      var key = window.location.href.split('/')[5].split('?')[0];
      var id = draftUniqueId;
      $.get(apiEndpoint + '/draftorders/' + id, {key: key}, function(response) {

        if(response.draft) {
          App.m.draft.id = response.draft.shopify_id;
          App.m.draft.items = response.draft.line_items;
          $('.change-draft').show();

          // Select line items that are currently included in the draft in
          // the change services ui.
          setTimeout(function() {
            $('.item-title').each(function() {
              var title = $(this).text().trim();
              var $checkbox = $(this).find('input[type=checkbox]');
              
              $('.product__description__name').each(function() {
                if(title == $(this).text().trim()) {
                  $checkbox.prop('checked', true);
                }
              });
            });
          }, 100);
        }
      }, 'json');
    }
    
    if(draftTax > 0) {
      Checkout.showDraftTax(draftTax);
    }

    // Show discount text for line items.
    var i = 0;
    $('.product__description').each(function() {
      $(this).find('.order-summary__small-text').text(discounts[i]);
      i++;
    });
  }

  Checkout.validateAddress = function(zip, validCallback, invalidCallback) {

    console.log('validate');
    
    $('.city-suggestions').remove();

    // Make a request to the google geocode api
    $.get('https://maps.googleapis.com/maps/api/geocode/json?address='+zip+'&components=country:'+App.country+'&language='+App.country, function(response){
      
      var result = Checkout.processAddressResponse(response);

      // For Germany site also include Austria.
      if(App.country == 'de') {
        $.get('https://maps.googleapis.com/maps/api/geocode/json?address='+zip+'&components=country:at', function(response) {

          var atResult = Checkout.processAddressResponse(response);

          if(result.cities.length == 0 && atResult.cities.length == 0) {
            if(validCallback != undefined) {
              validCallback();
            }
            return true;
          }

          return Checkout.handleAddressValidation(zip, [result, atResult], validCallback, invalidCallback);
        });
      }
      else {

        if(result.cities.length == 0) {
          if(validCallback != undefined) {
            validCallback();
          }
          return true;
        }
        return Checkout.handleAddressValidation(zip, [result], validCallback, invalidCallback);

      }
    });
  }

  Checkout.handleAddressValidation = function(zip, results, validCallback, invalidCallback) {

    var enteredCity = $('#checkout_shipping_address_city').val();
    var found = false;
    var citiesHtml = '';
    var zips = [];

    for(var i = 0; i < results.length; i++) {
      var result = results[i];
      var cities = result.cities;
      var city = result.city;
      
      if(result.googleZip == zip) {
        for(var i = 0; i < cities.length; i++) {
          if(enteredCity.toLowerCase().trim() == cities[i].city.toLowerCase())
            found = true;

          citiesHtml += '<li><span class="city">' + cities[i].city + '</span>, <span class="state">' + cities[i].state + '</span></li>';
        }
      }
    }

    if(!found && citiesHtml.length > 0) {
      var recommendations = "<div class='city-suggestions'><p>We don't recognize that city and zip code combination. Do you mean:</p>";
      recommendations += "<ul>" + citiesHtml + '</ul></div>';
      $('.section--shipping-address .section__content').before(recommendations);

      if(invalidCallback != undefined) {
        invalidCallback();
      }
      return false;
    }

    if(validCallback != undefined) {
      validCallback();
    }
    return true;
  }

  Checkout.translateCAtoFrench = function() {

    var english = [
      'Customer information',
      'Shipping method',
      'Payment method',
      'Already have an account?',
      'Log in',
      'Email',
      'Confirm Email',
      'Shipping address',
      'First name',
      'Last name',
      'Apt, suite, etc. (optional)',
      'Address',
      'City',
      'Country',
      'Province',
      'Postal code',
      'Phone',
      'Save this information for next time',
      'Continue',
      'Return to customer information',
      'Edit',
      'This is an estimate. There is no charge at this time. Upon evaluation, a quote will be emailed for approval.',
      'Return to shipping method',
      'Complete order',
      'I agree with the',
      'Terms and Conditions',
      'and',
      'Privacy Policy',
      'All rights reserved Fossil Group Services'
    ];

    var partial = [
      'Log in',
      'I agree with the',
      'and'
    ];

    var partialFrench = [
      'Ouvrir une session',
      'J\'accepte les',
      'ainsi qe la'
    ];

    var french = [
      'Informations client',
      'Livraison',
      'Facturation et paiement',
      'Vous avez déjà un compte',
      'Log in',
      'Adresse e-mail',
      'Confirm Email',
      'Adresse de livraison',
      'Prénom',
      'Nom',
      'App, suite, etc. (optionnel)',
      'Adresse',
      'Ville',
      'Pays',
      'Province',
      'Code postal',
      'Téléphone',
      'Sauvegarder mes coordonnées pour la prochaine fois',
      'Continuer',
      'Modifier ma demande de réparation',
      'Modifier',
      'Ceci est un devis. Il n’y a pas de frais pour l’instant. Après l’évaluation un devis sera envoyé par mail pour approbation.',
      'Retour aux informations de contact',
      'Finaliser',
      'J\'accepte les',
      'Termes et Conditions',
      'ainsi qe la',
      'Politique de Confidentialité',
      'All rights reserved Fossil Group Services[fr]'
    ];

    $('.main').find('input, p, span, div, h2, label, a').each(function(e) {
      for(var i=0; i<english.length; i++) {
        var word = english[i].trim();
        var text = $(this).html().trim();
        if(text == word) {
          $(this).text(french[i]);
        }

        if($(this).attr('placeholder') == word) {
          $(this).attr('placeholder', french[i]);
        }
      }
    });

    $('.main').find('input, p, span, div, h2, label, a').each(function(e) {
      for(var i=0; i<partial.length; i++) {
        var word = partial[i].trim();
        var html = $(this).html().trim();
        if(html.indexOf(word) >= 0) {
          $(this).html($(this).html().replace(word, partialFrench[i]));
        }
      }
    });
  }

  Checkout.processAddressResponse = function(response) {
    
    if(response.results.length == 0) {
      return { cities: [] };
    }

    var city = '';
    var state = '';
    var googleZip = '';

    var address_components = response.results[0].address_components;
    $.each(address_components, function(index, component){
      var types = component.types;
      $.each(types, function(index, type){
        if(type == 'locality') {
          city = component.long_name;
        }
        if(type == 'administrative_area_level_1') {
          state = component.short_name;
        }
        if(type == 'postal_code') {
          googleZip = component.short_name;
        }
      });
    });

    var cities = [];
    var cityList = response.results[0].postcode_localities;
    if(cityList) {
      $.each(cityList, function(index, locality) {
        cities.push({ city: locality, state: state });
      });
    }
    
    if(cities.length == 0 && city) {
      cities.push({ city: city, state: state });
    }

    return {
      city: city,
      googleZip: googleZip,
      cities: cities
    };
  }

}(window.Checkout = window.Checkout || {}, jQuery));

